import { fromEvent } from "rxjs";

export const onDrawerClosed$ = fromEvent(document.body, "drawerClosed");
export const onDocumentPointerMove$ = fromEvent(document, 'pointermove');
export const onDocumentPointerUp$ = fromEvent(document, 'pointerup');
export const onOrientationChange$ = fromEvent(window, 'orientationchange');
export const onDocumentClicked$ = fromEvent(document, 'click');
export const onDocumentKeyDown$ = fromEvent(document, 'keydown');